import { ReactElement } from 'react';
import { DataGridToolbarActions } from 'components/common/dataGrid/DataGridToolbarActions';
import { DocumentStateToggle } from './DocumentStateToggle';
import { GridColumnFieldDocumentation } from 'components/common/dataGrid/columnsFactory/types';

export function DocumentationDataGridActions(): ReactElement {
  return (
    <DataGridToolbarActions
      columnsDataQa='documentation-table-column-settings-button'
      excludeField={GridColumnFieldDocumentation.state}
      afterColumns={<DocumentStateToggle />}
      sx={{ height: '100%', gap: { xs: 0.5, sm: 1 } }}
    />
  );
}
